import { Input, Label } from "reactstrap";
import { AsyncPaginatedSelect } from "components/common/AsyncPaginatedSelect";
import {
  LeaveApplicationStatus,
  LeaveApplicationStatusLabel,
} from "../constants/leave-application.constants";
import { getLeaveTypeOptions } from "../services/LeaveTypeService";
import { getEmployeeOptions } from "features/Employees/services/EmployeeService";
import {
  EmployeeOption,
  EmployeeSingleValue,
} from "features/Employees/components/EmployeeSelectComponents";

export type LeaveApplicationListFiltersProps = {
  statusFilter: LeaveApplicationStatus | "";
  onStatusChange: (value: LeaveApplicationStatus | "") => void;
  leaveTypeId: number | null;
  onLeaveTypeChange: (id: number | null) => void;
  showEmployeeFilter: boolean;
  employeeId: number | null;
  onEmployeeChange: (id: number | null) => void;
};

export default function LeaveApplicationListFilters({
  statusFilter,
  onStatusChange,
  leaveTypeId,
  onLeaveTypeChange,
  showEmployeeFilter,
  employeeId,
  onEmployeeChange,
}: LeaveApplicationListFiltersProps) {
  return (
    <div className="d-flex flex-wrap align-items-end gap-3">
      {showEmployeeFilter && (
        <div style={{ minWidth: "14rem" }}>
          <Label className="form-label small text-muted mb-1">Employee</Label>
          <AsyncPaginatedSelect
            fetchOptions={getEmployeeOptions}
            placeholder="All employees"
            value={employeeId}
            onChange={(opt: any) => {
              const v = opt && !Array.isArray(opt) ? opt.value : null;
              onEmployeeChange(v != null ? Number(v) : null);
            }}
              components={{
              Option: EmployeeOption,
              SingleValue: EmployeeSingleValue,
            }}
          />
        </div>
      )}
      <div style={{ minWidth: "13rem" }}>
        <Label className="form-label small text-muted mb-1">Leave type</Label>
        <AsyncPaginatedSelect
          fetchOptions={getLeaveTypeOptions}
          placeholder="All types"
          value={leaveTypeId}
          onChange={(opt: any) => {
            const v = opt && !Array.isArray(opt) ? opt.value : null;
            onLeaveTypeChange(v != null ? Number(v) : null);
          }}
        />
      </div>
      <div style={{ minWidth: "12rem" }}>
        <Label className="form-label small text-muted mb-1">Status</Label>
        <Input
          type="select"
          className="form-select"
          value={statusFilter}
          onChange={(e) =>
            onStatusChange(e.target.value as LeaveApplicationStatus | "")
          }
        >
          <option value="">All statuses</option>
          {(Object.values(LeaveApplicationStatus) as LeaveApplicationStatus[]).map((s) => (
            <option key={s} value={s}>
              {LeaveApplicationStatusLabel[s]}
            </option>
          ))}
        </Input>
      </div>
    </div>
  );
}
